import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "side-bar unfold-status" }
const _hoisted_2 = { class: "menu-list" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "active-icon" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon = _resolveComponent("icon")
  const _component_a_button = _resolveComponent("a-button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.navLinks, (item) => {
        return (_openBlock(), _createBlock("div", {
          key: item.id,
          class: ["menu-item", { 'active-menu': _ctx.hasOwnMenu(item, _ctx.route.name) }]
        }, [
          _createVNode(_component_a_button, {
            type: "link",
            class: "item-btn",
            onClick: ($event: any) => (_ctx.toRouter(item))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_icon, {
                name: item.icon,
                scale: 2
              }, null, 8, ["name"]),
              _createTextVNode(" " + _toDisplayString(item.name), 1)
            ]),
            _: 2
          }, 1032, ["onClick"]),
          _createVNode("ul", null, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.children, (child) => {
              return (_openBlock(), _createBlock("li", {
                key: child.id,
                class: {
                            'active-router': _ctx.hasOwnMenu(child, _ctx.route.name),
                        }
              }, [
                _createVNode(_component_a_button, {
                  type: "link",
                  onClick: ($event: any) => (_ctx.toRouter(child))
                }, {
                  default: _withCtx(() => [
                    _hoisted_3,
                    _createTextVNode(_toDisplayString(child.name), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ], 2))
            }), 128))
          ])
        ], 2))
      }), 128))
    ])
  ]))
}